import h from 'virtual-dom/h';
import {DefaultSettings, settings} from '../../../settings/settings-util';
import { isActiveSession } from '../../../util/session';
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../wireup/AlmeState";
import {HistoryMessage, HistoryMessageError} from "../../../types/history";
import {VChild, VNode, VTree} from "virtual-dom";
import {Dictionary, Mutator} from "../../../types/rendering";

type MutatorModule = { getMutator: () => Mutator };

export default class ErrorMessageRenderer
{
    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _mutatorModules: MutatorModule[];
    _mutators: Mutator[] = [];

    constructor(passedSettings?: DefaultSettings, mutatorModules: MutatorModule[] = [])
    {
        this._settings = passedSettings ?? settings;
        this._mutatorModules = mutatorModules;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
        this._mutators = this._mutatorModules.reduce((mutators, module) => [...mutators, module.getMutator()], [] as Mutator[]);
    }

    static getDefaultSettings(): DefaultSettings
    {
        return settings;
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    doesRender(message: HistoryMessage): boolean
    {
        return message.type === this._settings.messageConstants.errorResponseType;
    }

    getRenderer(): (message: HistoryMessage) => VChild
    {
        return (message: HistoryMessage): VChild =>
        {
            if (!this.doesRender(message)) { return []; }

            const messageError = message as HistoryMessageError;
            const isAuthError = messageError?.statusCode === 401;
            const className   = this._settings.classNames.almeResponseErrorClassName + (isAuthError ? '_autherror' : '');

            const properties = {
                className,
            } as Dictionary;

            this._mutators.reduce((props, mutate) => mutate(props), properties);

            const { postMarkdownVdomElements } = messageError.extensionData;
            const textChildren = (postMarkdownVdomElements as VTree[])?.length > 0 ? (postMarkdownVdomElements as VTree[]) : messageError.errorText;

            let errorMessage = h('span', properties, [h('p', {}, textChildren)]);
            if(this._settings.Error.defaultLinks || this._settings.Error.launchLinks) {
                errorMessage = this.generateErrorMessageWithLinks(errorMessage);
            }

            return errorMessage;
        };
    }

    generateErrorMessageWithLinks(errorMessage: VNode): VNode{
        //Checks if the error message is happening on launch and if the client
        //has a unique launch links set
        const isOnLaunch  = !isActiveSession(this._settings, this._store);
        const links = (!isOnLaunch || !this._settings.Error.launchLinks)
            ? this._settings.Error.defaultLinks
            : this._settings.Error.launchLinks;


        links.forEach(link => {
            const href = (typeof link.href === "function" && this._store?.getState())
                ? link.href(this._settings, this._store.getState(), window)
                : link.href;

            errorMessage.children.push(
                h('a',
                    {
                        className: this._settings.classNames.almeResponseErrorLink,
                        href,
                        title: link.title,
                        target: link.target,
                    },
                    link.displayText)
            );
        });

        return errorMessage;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-errors/src/message-renderer-errors.ts